import React from 'react';
import './AppDevelopmentNew.css';
import appImage from '../assets/app (1).png';

const AppDevelopmentNew = () => {
  return (
    <section className="app-development-section">
      <div className="container app-development-content">
        <div className="app-development-text">
          <h5>APP DEVELOPMENT</h5>
          <h2>Innovative and Scalable App Development Solutions</h2>
          <p>
            At JN IT Solutions, we specialize in creating custom mobile and web applications tailored to your business needs. Our expert team ensures seamless user experience, robust performance, and scalable architecture.
          </p>
          <ul>
            <li>✔ Native and cross-platform app development</li>
            <li>✔ Agile development process with continuous delivery</li>
            <li>✔ Integration with latest technologies and APIs</li>
          </ul>
          <p>
            Whether you need a startup MVP or a full-fledged enterprise app, we deliver quality solutions that drive growth and engagement.
          </p>
          <button className="get-started-btn">Get Started</button>
        </div>
        <div className="app-development-image-container">
          <img src={appImage} alt="App Development" />
        </div>
      </div>
    </section>
  );
};

export default AppDevelopmentNew;
